module.exports = __webpack_public_path__ + "img/icon-partner.169e75d7.png";